import type { ToastInput } from "@/features/toast/types"

/**
 * Лёгкая шина событий для тостов. ToastProvider подписывается, а singleton `toast.*`
 * публикует — так можно показывать тосты из любого места (включая api-слой), не создавая
 * циклических импортов между http/провайдерами.
 */
type Listener = (input: ToastInput) => void

const listeners = new Set<Listener>()

export const toastBus = {
  subscribe(listener: Listener) {
    listeners.add(listener)
    return () => {
      listeners.delete(listener)
    }
  },
  publish(input: ToastInput) {
    for (const listener of listeners) listener(input)
  },
}
